import React, { useEffect } from "react";
import styled from "styled-components";
import countries from "lib/countries";

const AdBanner = styled.div`
  width: 100%;
  max-width: ${(props) => (props.type === "banner" ? "970px" : "100%")};
  padding: 0 1.5rem;
  margin: 0 auto;
`;

const AdIns = styled.ins`
  display: inline-block;
  vertical-align: top;
  background-color: #f5f5f5;
  width: 100%;
  max-width: ${(props) => (props.type === "banner" ? "970px" : "100%")};
  height: ${(props) => (props.type === "banner" ? "90px" : "300px")};
`;

export const hasAdSense = (props) => {
  if (!props.user) return false;

  if (!props.enabled) return false;

  if (!props.slot) return false;

  let country = props.user.country;
  country = countries.includes(country) ? country : "OTHER";

  return props[props.location][country];
};

const AdSense = (props) => {
  // Check AdSense should/can be displayed
  if (!hasAdSense(props)) return null;

  useEffect(() => {
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (err) {
      console.error(err);
    }
  }, []);

  return (
    <AdBanner type={props.type}>
      <AdIns
        type={props.type}
        className="adsbygoogle"
        data-ad-client={process.env.NEXT_PUBLIC_ADSENSE_CLIENT}
        data-ad-slot={props.slot}
      />
    </AdBanner>
  );
};

export default AdSense;
